import { FaHammer, FaBuilding, FaCity } from 'react-icons/fa';
import images from './images';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaHammer />,
    title: 'Basic {Package}',
    price: 5000.00,
    features: [
      'Site Evaluation',
      'Basic Foundation Work',
      'Structural Framing',
      'Standard Materials',
      '1-Year Warranty',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaBuilding />,
    title: 'Standard {Package}',
    price: 15000.00,
    features: [
      'Site Analysis',
      'Advanced Foundation Work',
      'Quality Framing & Roofing',
      'Interior & Exterior Finishing',
      '5-Year Warranty',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaCity />,
    title: 'Premium {Package}',
    price: 30000.00,
    features: [
      'Custom Architectural Design',
      'High-Quality Materials',
      'Smart Home Integration',
      'Luxury Interior Finishing',
      '10-Year Warranty',
    ],
  },
];

export default pricing;
